import ImageLinks from './utils/ImageLinks';
import FilteredItems from './utils/item-filter/ItemFilter';

export default function MerchantPage() {

  return (
    <div>
      <ImageLinks />
      <FilteredItems />
    </div>
  );
}
